import type { RouteViewModel } from '../types/routeViewModel';

/** Токен для пересборки клиентского индекса аллокаций при обновлении view маршрута. */
export function routeViewCargoAllocationRefreshToken(view: RouteViewModel | null | undefined): string {
  if (!view) return '';
  const list = view.structure?.allocations ?? [];
  const sig = list
    .map((a) => {
      const o = a as Record<string, unknown>;
      const cid = Number(o.cargoId);
      const q = Number(o.allocatedQuantity ?? 0);
      return `${Number.isFinite(cid) ? cid : 'x'}:${Number.isFinite(q) ? q : 0}`;
    })
    .sort()
    .join(';');
  return `${view.builtAt}|${view.sourceRevision?.routeUpdatedAt ?? ''}|${sig}`;
}
